import React, { Component } from 'react';
import Cookies from 'universal-cookie';

import Header from '../../../components/Header/Header';

import illustration from '../../../assets/img/illustrations/404.png'
// Import Style
import '../style.scss';

class AuthGeneralError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: `We're experiencing technical difficulties at the moment please try again later!`,
    };
  }

  componentDidMount() {
    const cookies = new Cookies();
    const error = cookies.get('AERR');
    if (error) {
      this.setState({
        message: error,
      });
    }
  }

  render() {
    return (
      <div className='downtime'>
        <Header showHome={false} />

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>Something went wrong</h1>
            <p>{this.state.message}</p>
            <a className='btn btn-primary' href="/login" id="loginBtn">
              Let's try that again
            </a>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={illustration}/>
          </div>
        </div>
      </div>
    );
  }
}
export default AuthGeneralError;
